var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 11.5625,
    stroke: "#F31260",
    strokeWidth: 1.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9444 10.0789L20.6156 8.75L15.3472 14.0184L10.0789 8.75L8.75 10.0789L14.0184 15.3472L8.75 20.6156L10.0789 21.9444L15.3472 16.6761L20.6156 21.9444L21.9444 20.6156L16.6761 15.3472L21.9444 10.0789Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelUser);
export default __webpack_public_path__ + "static/media/cancel-user.e88468889242116d1d239362bceccabd.svg";
export { ForwardRef as ReactComponent };